import { render } from "./KoFooter.vue?vue&type=template&id=1445e864&scoped=true"
const script = {}

import "./KoFooter.vue?vue&type=style&index=0&id=1445e864&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1445e864"]])

export default __exports__